import React from "react";
//import Styles from './DynamiteSessions.module.scss';

export default function DynamiteSessions() {
  return <>Dynamite session</>;
}
